var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quill-editor',{ref:"myTextEditor",attrs:{"config":_vm.editorOption},model:{value:(_vm.pages.content),callback:function ($$v) {_vm.$set(_vm.pages, "content", $$v)},expression:"pages.content"}})}
var staticRenderFns = []

export { render, staticRenderFns }